import { Validator } from '@vista-digital/validator';
export const defaultFilmTrailerDisplayText = {
    failedToLoadTrailerTitle: 'Sorry, something went wrong.',
    failedToLoadTrailerRetryButtonLabel: 'Retry'
};
export const filmTrailerDisplayTextValidatorSchema = {
    failedToLoadTrailerTitle: Validator.nonEmptyString,
    failedToLoadTrailerRetryButtonLabel: Validator.nonEmptyString
};
export const filmTrailerDisplayTextValidator = Validator.object(filmTrailerDisplayTextValidatorSchema);
//# sourceMappingURL=display-text.js.map